import { Button, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useCallback, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import CustomAlert from './CustomAlert';
import { DelelteFontIcon, DeleteIcon } from './CustomIcons';

const MAX_FILE_SIZE = 5242880;

const useStyles = makeStyles((theme) => ({
    content_file: {
        border: '2px dotted #ccc',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(0.5),
        margin: theme.spacing(1, 0),
        cursor: 'pointer',
    },
    text: {
        color: theme.palette.text.link,
    },
    preview: {
        position: 'relative',
        display: 'flex',
        border: '1px solid #eee',
        borderRadius: theme.spacing(0.5),
        padding: 4
    },
    imgFile: {
        height: '100%',
        width: '100%',
    },
    delete: {
        position: 'absolute',
        right: 10,
        top: 10
    },
    icon_delete: {
        width: theme.spacing(2.5),
        height: theme.spacing(2.5),
        borderRadius: theme.spacing(0.3),
        background: theme.palette.common.white,
        "&:hover": {
            cursor: 'pointer',
        },
        textAlign: 'center',
    },
    box_image: {
        width: 150,
        height: 150,
    },
    delete_file: {
        position: 'absolute',
        right: 0,
    }
}));


export default function CustomUploadFile(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { name, id, desc, isPreview, buttonLabel, isMulti } = props;
    const [file, setFile] = useState({});
    const [message, setMessage] = useState({});
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [files, setFiles] = useState([]);

    const onUpload = async (files) => {
        let allFiles = selectedFiles;
        console.log("files===", files);
        files.map(file => {
            let checkType = onCheckType(file.type);
            let checkSize = checkFileSize(file.size);
            if (checkType && checkSize) {
                Object.assign(file, {
                    preview: file ? URL.createObjectURL(file) : null,
                    formattedSize: formatBytes(file.size),
                }
                );
                let blob = new Blob([file], { type: file.type });
                let newFile = {
                    url: window.URL.createObjectURL(blob),
                    name: file.name,
                    type: file.type.split('/')[1].toLowerCase()
                }
                setFile(newFile);
            }
        });
        allFiles = selectedFiles;
        allFiles.push(...files);
        console.log("allFiles===", allFiles);
        await setSelectedFiles(allFiles);
        if (props.onUploadFile) await props.onUploadFile(allFiles);
    }
    const checkFileSize = (size) => {
        if (size && size > MAX_FILE_SIZE) {
            setMessage({
                show: true,
                content: t('error_file_size') + formatBytes(MAX_FILE_SIZE)
            });
            return false;
        }
        return true;
    }
    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        let size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    const onCheckType = (fileType) => {
        console.log("file type===", fileType);
        let type = fileType ? fileType.split('/')[1].toLowerCase() : null;
        let types = ["png", "doc", "pdf", "json", "jpeg", "log", "svg", "docx", "eml", "xlsx", "csv", "xls", "msg", "txt"]
        if (types.includes(type)) return true;
        else {
            setMessage({
                show: true,
                content: t('error_file_upload')
            });
            return false;
        }
    }
    const onShowMessage = (message) => {
        setMessage(message)
    }
    const onDeleteFile = (file, i) => {
        let filterFiles = selectedFiles.filter((f, index) => index !== i);

        if (filterFiles && filterFiles.length > 0) {
            setFile(filterFiles[0]);
            setSelectedFiles(filterFiles);
        } else {
            setFile(undefined);
            setSelectedFiles([]);
        }
        if (this.props.onFileUpload) this.props.onFileUpload(filterFiles);
    }
    console.log("selectedFiles===", selectedFiles);
    return (
        <>
            <Dropzone onDrop={acceptedFiles => onUpload(acceptedFiles)}>
                {({ getRootProps, getInputProps }) => (
                    <>
                        {!buttonLabel && <section className={classes.content_file}>
                            <div {...getRootProps()}>
                                <input name={name} id={id} {...getInputProps()} />
                                <p className={classes.text}>{desc ? desc : t('upload_file_desc')}</p>
                            </div>
                        </section>}
                        {buttonLabel &&
                            <div {...getRootProps()}>
                                <input name={name} id={id} {...getInputProps()} />
                                <Button variant='contained' size='small'>{buttonLabel}</Button>
                            </div>}
                        {isPreview && <Grid item xs={12} container>
                            {selectedFiles.map((f, i) => {
                                return (
                                    f.preview && (
                                        <div key={i}>
                                            <section className={classes.preview}>
                                                {f.type && f.type != 'pdf' ?
                                                    <div className={classes.box_image}>
                                                        {/* <img src={f.preview} alt={f.name} className={classes.imgFile}></img> */}
                                                        <a href={f.preview} target="_blank">{f.name}</a>
                                                        <div className={classes.delete} onClick={() => onDeleteFile(f, i)}>
                                                            <div className={classes.icon_delete}><DelelteFontIcon /></div>
                                                        </div>
                                                    </div>
                                                    : <div>
                                                        <a href={f.preview} target='_blank'>{f.name}</a>
                                                        <div className={classes.delete_file} onClick={() => onDeleteFile(f, i)}>
                                                            <div className={classes.icon_delete}><DelelteFontIcon /></div>
                                                        </div>
                                                    </div>
                                                }
                                            </section>
                                        </div>
                                    )
                                );
                            })}
                        </Grid>}
                    </>
                )}
            </Dropzone>
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={() => onShowMessage({})}
            />}
        </>
    );
}